import Register from "../../register/Register";

export default function UserForm() {
  return (
    <div>
      <Register />
    </div>
  );
}
